import { getRecaptchaSiteKey } from './api.ts';

let siteKey = '';

export const initRecaptcha = async () => {
  siteKey = await getRecaptchaSiteKey();

  await loadRecaptcha(siteKey);
  await grecaptchaReadyAsync();
};

export const executeRecaptcha = async (recaptchaInput?: HTMLInputElement) => {
  const token = await grecaptcha?.execute(siteKey);

  if (recaptchaInput) {
    recaptchaInput.value = token;
  }
};

const grecaptchaReadyAsync = () => {
  return new Promise((resolve) => {
    grecaptcha?.ready(() => resolve(true));
  });
};

const loadRecaptcha = (siteKey: string) => {
  return new Promise((resolve) => {
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.grecaptcha);
    document.head.appendChild(script);
  });
};
